import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { Coord, GridConfig } from "../types/Interface";


export default class GridArea extends PIXI.Container {
  private Layers = Layers.getInstance();
  private graphics: PIXI.Graphics = this.addChild(new PIXI.Graphics());

  constructor(private GridConfig: GridConfig) {
    super()
    this.position.copyFrom(GridConfig);

    this.drawGrid();
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.BottomUnder.addChild(this);
  private drawGrid() {
    this.graphics.clear();

    const startX = -this.GridConfig.width / 2;
    const startY = -this.GridConfig.height / 2;

    // Vertical Lines
    for (let i = 0; i <= this.GridConfig.width / this.GridConfig.cellSize; i++) {
      this.graphics
        .moveTo(startX + i * this.GridConfig.cellSize, startY)
        .lineTo(startX + i * this.GridConfig.cellSize, startY + this.GridConfig.height);
    }

    // Horizontal Lines
    for (let j = 0; j <= this.GridConfig.height / this.GridConfig.cellSize; j++) {
      this.graphics.moveTo(startX, startY + j * this.GridConfig.cellSize)
        .lineTo(startX + this.GridConfig.width, startY + j * this.GridConfig.cellSize);
    }
    this.graphics.stroke({ color: this.GridConfig.lineColor, width: this.GridConfig.lineWidth })
  }
  static getGlobalCoord(gridConfig: GridConfig, coord: Coord): Coord {
    return {
      x: Math.floor((gridConfig.x - gridConfig.width / 2) + coord.x * gridConfig.cellSize),
      y: Math.floor((gridConfig.y - gridConfig.height / 2) + coord.y * gridConfig.cellSize)
    }
  }
}
